"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _ProductRecord = _interopRequireDefault(require("customer-data-objects/product/ProductRecord"));

var _FolderRecord = _interopRequireDefault(require("customer-data-objects/folder/FolderRecord"));

var _ProductProperties = require("customer-data-objects/product/ProductProperties");

var _actions = require("./actions");

var _actions2 = require("../Folders/actions");

var _FolderTypes = _interopRequireDefault(require("customer-data-objects/folder/FolderTypes"));

var initialState = _LoadingStatus.EMPTY;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.FetchProductActionTypes.SUCCESS:
      return action.payload.data;

    case _actions.CreateProductActionTypes.SUCCESS:
    case _actions.CreateProductAndAddAnotherActionTypes.SUCCESS:
      {
        var folderId = (0, _ImmutableModel.getProperty)(action.payload.props.product, _ProductProperties.FOLDER_ID) || null;

        if (action.payload.props.folderIdInView !== folderId) {
          return state;
        }

        return state.update('results', function (results) {
          return results.unshift(action.payload.data);
        });
      }

    case _actions.UpdateProductActionTypes.SUCCESS:
      {
        var _action$payload$data = action.payload.data,
            id = _action$payload$data.id,
            nextProperties = _action$payload$data.nextProperties;

        var _folderId = (0, _ImmutableModel.getProperty)(action.payload.props.product, _ProductProperties.FOLDER_ID) || null;

        if (action.payload.props.modifiedProperties.has(_ProductProperties.FOLDER_ID) && action.payload.props.folderIdInView !== _folderId) {
          return state.update('results', function (results) {
            return results.filterNot(function (object) {
              return object instanceof _ProductRecord.default && (0, _ImmutableModel.getId)(object) === id;
            });
          });
        }

        return state.update('results', function (results) {
          return results.map(function (object) {
            if (object instanceof _ProductRecord.default && (0, _ImmutableModel.getId)(object) === id) {
              return nextProperties.reduce(function (record, property, name) {
                return (0, _ImmutableModel.setProperty)(record, name, property.get('value'));
              }, object);
            }

            return object;
          });
        });
      }

    case _actions.DeleteProductActionTypes.SUCCESS:
      {
        var deletedIds = action.payload.props;
        return state.update('results', function (results) {
          return results.filterNot(function (object) {
            return object instanceof _ProductRecord.default && deletedIds.includes((0, _ImmutableModel.getId)(object));
          });
        });
      }

    case _actions2.CreateFolderActionTypes.SUCCESS:
      {
        if (action.payload.props.type !== _FolderTypes.default.PRODUCT) {
          return state;
        }

        return state.update('results', function (results) {
          return results.unshift(_FolderRecord.default.fromJS(action.payload.data));
        });
      }

    case _actions2.UpdateFolderActionTypes.SUCCESS:
      {
        if (action.payload.props.type !== _FolderTypes.default.PRODUCT) {
          return state;
        }

        var updatedFolder = _FolderRecord.default.fromJS(action.payload.data);

        var folderIndexToUpdate = state.get('results').findIndex(function (object) {
          return object instanceof _FolderRecord.default && object.folderId === updatedFolder.folderId;
        });
        return folderIndexToUpdate !== -1 ? state.setIn(['results', folderIndexToUpdate], updatedFolder) : state;
      }

    case _actions2.DeleteFolderActionTypes.SUCCESS:
      {
        if (action.payload.props.type !== _FolderTypes.default.PRODUCT) {
          return state;
        }

        return state.update('results', function (productsAndFolders) {
          return productsAndFolders.filterNot(function (object) {
            return object instanceof _FolderRecord.default && object.folderId === action.payload.props.folderId;
          });
        });
      }

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;